module.exports = __webpack_public_path__ + "img/flow-release.5af703e1.svg";